import { useAbility } from '@casl/vue'

const useAppAbility = () => useAbility()

export default {
  useAppAbility,
}
